import { animate } from 'motion';

const animatedBlocks = document.querySelectorAll('.animated-block');

animatedBlocks.forEach(container => {
  const animBlocks = container.querySelectorAll('.anim-block');

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animBlocks.forEach((block, i) => {
            const percent = getComputedStyle(block)
              .getPropertyValue('--percent')
              .trim();

            animate(
              block,
              {
                transform: [`translateY(${percent})`, 'translateY(0)'],
              },
              {
                duration: 0.7,
                delay: i * 0.25,
                easing: 'ease-in-out',
              }
            );
          });

          observer.unobserve(container);
        }
      });
    },
    { threshold: 0.5 }
  );

  observer.observe(container);
});
